import { Component, computed, input } from "@angular/core";

@Component({
  selector: "snt-mailto",
  standalone: true,
  templateUrl: "./mailto.component.html",
  styles: `
    :host {
      display: inline-block;
    }
  `
})
export class MailtoComponent {
  text = input<string | undefined>();
  hrefClass = input<string>("");
  mail = input.required<string>();

  href = computed<string>(() => `mailto:${this.mail()}`);
  displayText = computed<string>(() => this.text() || this.mail());
  isValidEmail = computed<boolean>(() => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const value = this.mail();
    if (!value) {
      return false;
    }
    return emailRegex.test(value);
  });
}
